import Divider from '@mui/material/Divider';
import type { Theme } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';

import { useSidebar } from '@src/context/hooks';

import {
  LogoSection,
  SidebarContainer,
  SidebarDrawer,
  SidebarGroup,
  SidebarNavItem,
  UserInfo,
} from './components';

function Sidebar() {
  const sidebar = useSidebar();
  if (!sidebar) {
    return null;
  }

  return (
    <SidebarDrawer variant="permanent" open={!sidebar.isCollapsed}>
      <Toolbar sx={StyleSheet.toolbar} >
        <LogoSection />
      </Toolbar>

      <Divider />
      <UserInfo />

      <SidebarContainer>
        <SidebarGroup sx={{ pt: 1 }}>
          {sidebar.items.top.map((item) => (
            <SidebarNavItem
              key={item.key}
              label={item.label}
              to={item.to}
              icon={item.icon}
            />
          ))}
        </SidebarGroup>

        <SidebarGroup>
          {sidebar.items.bottom.map((item) => (
            <SidebarNavItem
              key={item.key}
              label={item.label}
              to={item.to}
              icon={item.icon}
            />
          ))}
        </SidebarGroup>
      </SidebarContainer>
    </SidebarDrawer>
  );
}

Sidebar.displayName = 'Sidebar';

const StyleSheet = {
  toolbar: (theme: Theme) => ({
    marginLeft: '24px',
    marginRight: '24px',
    paddingTop: '24px',
    paddingLeft: { xs: 0, sm: 0 },
    paddingBottom: '20px',
    borderBottom: '1px solid',
    borderColor: theme.palette.grey[50],
  }),
};
export default Sidebar;
